import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { CardActionArea } from '@mui/material'

import cocktailImg from '../images/cocktail.webp'

const CocktailThumbnail = (props) => {
  const image = `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/static/${props.imageFileName}`

  return (
    <Card sx={{ width: 350, margin: 2 }}>
      <Link to={`/cocktail/${encodeURIComponent(props.id)}`}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="400"
            image={image}
            onError={(e) => (e.target.src = cocktailImg)}
            alt="cocktail image"
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              color="text.primary"
              component="div"
            >
              {props.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {props.description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  )
}

CocktailThumbnail.propTypes = {
  id: PropTypes.string.isRequired,
  imageFileName: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
}

export default CocktailThumbnail
